import { ReactComponent as ChangePasswordIconSvg } from './change-password.svg'
export default ChangePasswordIconSvg
